<template>
	<div class="printers-general-container">
		<CardSlashed v-if="userStore.currBusiness && printersStore.businessPrinters && Object.keys(printersStore.businessPrinters).length <= 0" class="card-link card-link-primary card-margin-bottom">
			<template #left>
				<div class="card-link-title">
					<div class="align-text">
						<h2>{{getString('dont_you_have_printer')}}</h2>
						<p>{{getString('manage_orders_better')}}</p>
					</div>
				</div>
			</template>
			<template #right>
				<div class="col-12 align-end card-link-body p-3">
					<div class="card-link-info">
						<div class="container-text-img">
							<p>{{getString('qromo_printer_subtitle')}}</p>
							<div class="wrapper-img">
								<picture>
									<source type="image/webp" srcset="https://img.qromo.io/img/Qromo-printer.webp">
									<img src="https://img.qromo.io/img/Qromo-printer.jpg" alt="product image">
								</picture>
							</div>
						</div>
						<div class="prices-row">
							<div class="prices-align">
								<p class="price-strike">{{ currPricePrinter }}</p>
							</div>
						</div>
					</div>
					<div class="card-link-actions" v-if="userStore.currBusiness">
						<AppButton @click="addToCartAndGoToShop"  :text="getString('add_to_cart')" outline inverted/>
					</div>
				</div>
			</template>
		</CardSlashed>
		<AppCard :title="getString('printers')" >
			<template #body>
				<AppList v-if="printers && printers.length" :items="printers">
					<template #printer-header-slot="{item}">
						<div class="row centered space-between row-clickable" @click="clickPrinterDropdown(item)">
							<p class="chevron-p">{{ item.title }}</p>
							<div class="chevron-container">
								<AvailabilityDot class="mr-10" v-if="!item.activePrinter" :type="1" />
								<AppChevronIcon :direction="item.active ? 'up' : 'down'" />
							</div>
						</div>
						<div class="row centered flex-start" @click="clickPrinterDropdown(item)">
							<div class="extra-text">
								<p>{{item.printerCaption}}</p>
							</div>
						</div>
					</template>
					<template #dropdown-slot="{item}">
						<PrinterSettings :printer-id="item.id" @printer-duplicated="(newPrinterId) => activePrinterId = newPrinterId"/>
					</template>
					<template #new-printer>
						<div class="row centered space-between row-clickable row-clickable-new-printer" @click="newActive = !newActive">
							<img :src="'https://img.qromo.io/img/vue/icons/icon-plus'+(userStore.darkMode ? '-dark' : '')+'.svg'" draggable="false" class="icon-dimension-15 mr-10" alt="icon plus">
							<p class="chevron-p">{{ getString('new_printer') }}</p>
							<div class="chevron-container">
								<AppChevronIcon :direction="newActive ? 'up' : 'down'" />
							</div>
						</div>
					</template>
					<template #new-printer-dropdown>
						<div class="row centered space-between no-wrap">
							<p class="mr-5">{{ getString('sn_code_located') }}</p>
							<AppTextInput ref="sn-input" :placeholder="getString('sn_code_example')" />
						</div>
						<div class="row centered space-between mt-15">
							<p></p>
							<AppButton :text="getString('add_printer')" @click="addPrinter" :loading="loadingNew" />
						</div>
						<div class="row row-help-center centered space-between">
							<p>{{getString("consult_guide_printer")}}</p>
							<AppButton outline :text="getString('label_button_help_desk_printer')" @click="openHelpDeskLink" />
						</div>
					</template>
				</AppList>
				<div v-else class="row no-printers-row">
					<p>{{getString('no_linked_printers')}}</p>
				</div>
			</template>
		</AppCard>
		<AppCard class="card-margin" :title="getString('settings')" :buttonText="getString('save')" @button-click="saveSettings">
			<template #body>
				<AppList :items="settingsItems" />
			</template>
		</AppCard>
		<CardSlashed v-if="userStore.currBusiness && printersStore.businessPrinters && Object.keys(printersStore.businessPrinters).length >= 1" class="card-link card-link-secondary card-margin">
			<template #left>
				<div class="card-link-title">
					<div class="icon-plugins" v-html="getIcon('iconPrinter')"></div>
					<div class="align-text">
						<h2>{{getString('do_you_need_more_printer')}}</h2>
						<p>{{getString('more_orders_management')}}</p>
					</div>
				</div>
			</template>
			<template #right>
				<div class="col-12 align-end card-link-body p-3">
					<div class="card-link-actions" v-if="userStore.currBusiness">
						<AppButton
							@click="addToCartAndGoToShop"
							:text="getString('add_to_cart')"
							outline
							inverted
						/>
					</div>
				</div>
			</template>
		</CardSlashed>
	</div>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import AppCard from "@/shared/components/AppCard.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppSwitch from "@/shared/components/AppSwitch.vue";
import PrinterSettings from "@/console-new/components/config/printers/PrinterSettings.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AvailabilityDot from "@/console-new/components/config/menu/AvailabilityDot.vue";
import {useShopStore} from "@/shop/stores";

import {useLanguageStore, useNotificationStore, useCurrencyStore, useSvgStore} from "@/shared/stores";
import {useUserStore, usePrintersStore} from "@/console-new/stores";
import API from "@/shared/helpers/API.js";
import CardSlashed from "@/console-new/components/shared/CardSlashed.vue";
import AppNumberInput from "@/shared/components/AppNumberInput.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let notificationStore = useNotificationStore();
		let svgStore = useSvgStore();
		let userStore = useUserStore();
		const shopStore = useShopStore();
		let printersStore = usePrintersStore();
		let currencyStore = useCurrencyStore();
		return {getString: languageStore.getString, currencyStore, showNotification: notificationStore.showNotification, getIcon: svgStore.get, printersStore, userStore, shopStore};
	},
	name: "PrintersContainer",
	components: {AppNumberInput, CardSlashed, AppList, AppCard, AppTextInput, AppButton, AvailabilityDot, AppChevronIcon, PrinterSettings, AppSwitch},
	data: () => ({
		activePrinterId: null,
		newActive: false,
		loadingNew: false,
	}),
	computed: {
		printers() {
			let printers = this.printersStore.businessPrinters || [];
			let finalPrinters = [];
			printers.forEach((printer) => {
				let caption = printer.printer_type === 'rt' ? this.getString('fiscal_printer') : this.getString('receipt_printer');
				if(printer.total_prints > 0) {
					caption += ' - '+this.getString("receipt_printed_param", [printer.total_prints]);
				}
				finalPrinters.push({
					id: printer.id,
					title: printer.name,
					printerCaption: caption,
					activePrinter: printer.active,
					customSlot: 'printer-header-slot',
					dropdownSlot: 'dropdown-slot',
					active: this.activePrinterId === printer.id,
				});
			});
			finalPrinters.push({
				title: 'new-printer',
				customSlot: 'new-printer',
				active: this.newActive,
				dropdownSlot: 'new-printer-dropdown',
			});
			return finalPrinters;
		},
		settingsItems() {
			return [
				{
					title: this.getString('other_cash_print'),
					switch: true,
					active: this.userStore && this.userStore.currBusiness ? this.userStore.currBusiness.print_cash_unaccepted : false,
					callback: v => { this.userStore.currBusiness.print_cash_unaccepted = v }
				},
				{
					title: this.getString('print_prebill_automatically'),
					switch: true,
					active: this.userStore && this.userStore.currBusiness ? this.userStore.currBusiness.print_auto_prebill : false,
					callback: v => { this.userStore.currBusiness.print_auto_prebill = v }
				},
				{
					title: this.getString('follow_preparation_future_orders'),
					explain: this.getString('follow_preparation_future_orders_explain'),
					switch: true,
					active: this.userStore && this.userStore.currBusiness ? this.userStore.currBusiness.print_orders_preparation_time : true,
					callback: v => { this.userStore.currBusiness.print_orders_preparation_time = v }
				},
			];
		},
		currPricePrinter() {
			return this.currencyStore.readableCurrencyValue(this.currencyStore.currCurrency.prices.qromoprinter.amount, false);
		},
	},
	methods: {
		addPrinter() {
			let sn = this.$refs['sn-input'].currentValue;
			if(!sn || sn.length < 5) {
				this.showNotification("printer-sn-error");
				return;
			}
			this.loadingNew = true;
			API.init().registerNewPrinter(this.userStore.currBusinessId, sn, (r) => {
				if(r && r.result) {
					if(r.result === "OK") {
						this.printersStore.businessPrinters = null;
						this.printersStore.getBusinessPrinters(() => {
							this.showNotification("generic-success");
							this.loadingNew = false;
							this.newActive = false;
						});
					} else if(r.details === "bind_error"){
						this.showNotification("printer-sn-error");
						this.loadingNew = false;
					} else {
						let bid = r.details === "already_registered" ? "#"+r.business_id : "";
						this.showNotification("duplicate-printer", [bid]);
						this.loadingNew = false;
					}
				} else {
					this.loadingNew = false;
				}
			});
		},
		saveSettings() {
			this.userStore.updateBusiness({print_cash_unaccepted: this.userStore.currBusiness.print_cash_unaccepted, print_auto_prebill: this.userStore.currBusiness.print_auto_prebill, print_orders_preparation_time: this.userStore.currBusiness.print_orders_preparation_time}, success => {
				this.showNotification(success ? 'generic-success' : 'generic-fail');
			});
		},
		clickPrinterDropdown(item) {
			this.activePrinterId = this.activePrinterId === item.id ? null : item.id;
		},
		addToCartAndGoToShop() {
			this.shopStore.addItemToCart({id:'qromoprinter'}, 1)
			this.shopStore.showCart = true;
			this.$router.push("/plugins/shop/qromoprinter");
		},
		openHelpDeskLink() {
			window.open('https://qromo-help.freshdesk.com/support/solutions/articles/202000076883-installazione-qromo-printer', '_blank');
		}
	},
	created() {
		this.printersStore.getBusinessPrinters();
	},
	mounted() {
		if(!this.userStore.businessUsers || !Object.keys(this.userStore.businessUsers).length) {
			this.userStore.getBusinessUsers();
		}
	},
	watch: {
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== null && newVal !== oldVal) {
				this.printersStore.getBusinessPrinters();
				this.userStore.getBusinessUsers();
				this.activePrinterId = null;
			}
		}
	},
}
</script>

<style lang="scss" scoped>
@use "@/console-new/assets/scss/_variables.scss" as *;
.printers-general-container {
	max-width: 1400px;
	margin: 0 auto;
}
.card-container:deep(.card-body) {
	padding: 0 !important;
	& > .list-container {
		.list-item:first-child::before {
			display: none;
		}
		.list-item:last-child::after {
			display: none;
		}
	}
}
.extra-text {
	width: 100%;
	cursor: pointer;
	p {
		font-size: 14px;
		line-height: 16px;
		color: var(--color-txt-1);
	}
	@media(max-width: 400px) {
		p {
			font-size: 12px;
		}
	}
}
.switch-header-wrapper {
	@include centered;
	justify-content: flex-end;
	@media (max-width: 350px) {
		width: 100%;
		margin-top: 10px;
	}
}
.icon-dimension-15 {
	width: 15px;
	height: 15px;
}
.chevron-p {
	width: calc(100% - 75px);
}
.chevron-p, .no-printers-row p {
	@media (max-width: 600px) {
		font-size: 14px;
	}
	@media (max-width: 400px) {
		font-size: 12px;
	}
}
.no-printers-row {
	@include centered;
	justify-content: flex-start;
	padding: 10px;
}
.row-clickable {
	cursor: pointer;
	&-new-printer {
		background-color: var(--color-bg-primary-2);
		padding: 5px 10px;
		border-radius: 13px;
		.chevron-p {
			color: var(--color-primary);
		}
	}
	.chevron-container {
		@include centered;
		justify-content: flex-end;
		width: 50px;
		height: 35px;
	}
}
.card-margin {
	margin-top: $mainPadding;
}
.card-margin-bottom {
	margin-bottom: $mainPadding;
}
.no-wrap {
	flex-wrap: nowrap;
}
.card-link {
	.card-link-title {
		width: 100%;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		margin-bottom: 10px;
		gap: 10px;

		.icon-plugins {
			display: inline-block;
			width: 15px;
			height: 15px;
			margin-top: 4px;

			&:deep(svg) {
				width: 15px;
				height: 15px;
				.fill { fill: var(--color-txt-white); }
				.stroke { stroke: var(--color-txt-white); }
			}
		}
		.align-text {
			display:flex;
			flex-direction: column;
		}
		h2 {
			font-size: 22px;
			display: inline-block;
			width: calc(100% - 15px);
			color: var(--color-txt-white);
			@media (max-width: 500px) {
				font-size: 20px;
				line-height: normal;
			}
		}
		p {
			font-size: 14px;
			line-height: 18px;
			color: var(--color-txt-white);
			margin-top: 5px;
		}
		&.no-icon {
			h2 {
				width: 100%;
				padding-left: 0;
			}
		}
	}
	.card-link-info {
		width: 100%;
		.prices-align {
			display: flex;
			margin-top: 8px;
			padding: 8px 0;
			border-top: 1px solid rgba(255,255,255,.5);
			justify-content: flex-end;
			p {
				font-size: 18px;
				font-weight: 500;
				color: var(--color-txt-white);
			}
		}
		.container-text-img {
			display: flex;
			justify-content: space-between;
			.wrapper-img {
				position: relative;
				width: 80px;
				height: 80px;
				overflow: hidden;
				border-radius: 13px;
				&:after {
					position: absolute;
					content: "";
					width: 100%;
					height: 100%;
					top: 0;
					left: 0;
					border-radius: 13px;
					box-shadow: inset 1px 2px 3px var(--color-box-shadow-3);
				}
				img {
					object-fit: contain;
					height: 100%;
					width: 100%;
				}
			}
			p {
				padding-right: 10px;
				width: calc(100% - 100px);
				color: var(--color-txt-white);
			}
		}
	}
	&-primary {
		&:deep(.slashed-card-container) {
			background: linear-gradient(198deg, #FC7502 0%, rgb(47, 36, 209) 100%);
			.slashed-left {
				@media (max-width: 500px) {
					padding-right: 10px;
					padding-bottom: 0;
				}
			}
		}
	}
	&-secondary {
		&:deep(.slashed-card-container) {
			background: linear-gradient(198deg, #FC7502 0%, rgb(47, 36, 209) 100%);
			.slashed-left {
				&::after {
					border-left: 1px solid var(--color-primary);
					@media (max-width: 500px) {
						border-left: none;
						border-top: 1px solid var(--color-primary);
					}
				}
			}
		}
		.card-link-title {
			.icon-plugins {
				&:deep(svg) {
					.fill { fill: var(--color-txt-white); }
					.stroke { stroke: var(--color-txt-white); }
				}
			}
			h2 {
				color: var(--color-txt-white);
			}
			p {
				color: var(--color-txt-white);
			}
		}
		.align-end {
			align-self: flex-end;
		}
	}
}
.row-help-center {
	margin-top: 15px;
	padding: 15px 0 0;
	border-top: 1px solid var(--color-border-alpha);
}


</style>